import billingModule from '../../billing.module';
import template from './billingPaymentHistory.component.html';
import style from './billingPaymentHistory.component.css';

export default billingModule.component('billingPaymentHistory', {
    template,
    style,
    controller(
        billingColorConstants,
        billingPaymentHistoryService,
        asNotifier,
        textResources
    ) {
        var vm = this;
        vm.rangeStart = 0;
        vm.rangeEnd = 0;
        vm.show = true;

        vm.getItems = criteria => {
            return billingPaymentHistoryService
                .getPaymentHistories(
                    (criteria.currentPage - 1) * criteria.itemsPerPage,
                    criteria.itemsPerPage
                )
                .then(
                    data => {
                        vm.show = data.size > 0;
                        vm.rangeStart = data.size == 0 ? 0 : data.offset + 1;
                        vm.rangeEnd = data.offset + data.items.length;

                        return {
                            items: data.items,
                            totalItems: data.size
                        };
                    },
                    data => {
                        vm.show = false;
                        vm.rangeStart = 0;
                        vm.rangeEnd = 0;
                        asNotifier.error(
                            `${textResources.genericError} ${
                                textResources.ifProblemPersists
                            }`
                        );
                        return {
                            items: data.items,
                            totalItems: data.size
                        };
                    }
                );
        };

        vm.paymentHistory = {
            id: 'asuiTable',
            options: {
                sortable: false,
                checkBox: 'none',
                colorConstants: billingColorConstants,
                showHeader: true,
                dragSort: false,
                orderInput: false,
                showHeaderWhenNoData: false,
                retrieveItemsAsync: vm.getItems,
                paging: {
                    currentPage: 1,
                    itemsPerPage: 20
                },
                columns: []
            }
        };
        vm.$onInit = () => {
            billingPaymentHistoryService.getColumns().then(
                data => {
                    vm.paymentHistory.options.columns = data;
                },
                () => {
                    asNotifier.error(
                        `${textResources.getPaymentHistoryColumnFail} ${
                            textResources.ifProblemPersists
                        }`
                    );
                }
            );
        };
    }
});



// WEBPACK FOOTER //
// ./modules/billing/components/billing-payment-history/billingPaymentHistory.component.js